export const refreshOnceOnDynamicImportError = (e: Error) => {
  if (/Failed to fetch dynamically imported module:(.*).js/.test(e.message)) {
    // This error occurs when existing clients try to navigate after a new deploy goes out. It is resolved by refreshing the html.
    if (window.sessionStorage.getItem("lastErrorMessage") !== e.message) {
      // Prevent infinite refresh loop by storing the last error message and only attempting refresh once
      window.sessionStorage.setItem("lastErrorMessage", e.message);
      window.location.reload();
    }
  }
};

export const ErrorComponent = () => (
  <div
    style={{
      margin: "20%",
    }}
  >
    <h2
      style={{
        textAlign: "center",
      }}
    >
      Something went wrong.
    </h2>
    <h4
      style={{
        textAlign: "center",
      }}
    >
      Please contact Backpack Support if the problem persists.
    </h4>
  </div>
);
